import PropTypes from 'prop-types';

export const GLAccountPropTypes = PropTypes.shape({
  createdSSO: PropTypes.string,
  glAccount: PropTypes.string.isRequired,
  listName: PropTypes.string.isRequired,
  periodName: PropTypes.string.isRequired,
  slGlJournalExists: PropTypes.number.isRequired,
  updatedSSO: PropTypes.string,
});

export const GLAccountListPropTypes = PropTypes.arrayOf(GLAccountPropTypes);

export const ModalPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    glAccount: PropTypes.string.isRequired,
  }),
});

export const ListNamePropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
});

export const ListNamesPropTypes = PropTypes.arrayOf(ListNamePropTypes);
